import { Text } from "@ttc3k/trekker";
import { Trans, useTranslation } from "react-i18next";
import { LinkButton } from "@ttc3k/trekker";
import { Center, CenterProps, Flex, styled } from "styled-system/jsx";
import { ApolloError } from "@apollo/client";
import { useHelpScout } from "shared/hooks";

type ReservationErrorProps = CenterProps & {
  error: ApolloError | undefined;
  orderId: string;
};

export const ReservationError = ({
  error,
  orderId,
  ...props
}: ReservationErrorProps) => {
  const { t } = useTranslation("storefront", {
    keyPrefix: "RESERVATION_DETAILS.ERROR",
  });
  const { handleBeaconClick } = useHelpScout();

  return (
    <Center w="100%" h="100%" {...props}>
      <Flex flexDir="column" alignItems="center" gap="400" maxW="350px">
        <Text visual="bodySemiBold" color="text.error.mid">
          {t("TITLE")}
        </Text>
        <Text visual="bodyMedium" color="text.mid" textAlign="center">
          <Trans
            i18nKey="storefront:RESERVATION_DETAILS.ERROR.DESCRIPTION"
            values={{ orderId }}
            components={{
              Span: <styled.span color="text.accent.magenta.mid" />,
            }}
          />
        </Text>
        {error?.message && (
          <Text visual="smallMedium" color="text.light" textAlign="center">
            {error?.message}
          </Text>
        )}
        <Text visual="bodyMedium" color="text.mid" textAlign="center">
          <Trans
            i18nKey="storefront:RESERVATION_DETAILS.ERROR.SUPPORT"
            values={{ orderId }}
            components={{
              Link: <LinkButton onClick={() => handleBeaconClick({})} />,
            }}
          />
        </Text>
      </Flex>
    </Center>
  );
};
